import React from 'react';
import { Link } from 'react-router-dom';
import { bool, func, object, string } from 'prop-types';

/**
 * A react router link that can be disabled, if it is disabled, just return a span instead of the Link
 * @param {object} children - the children to be rendered in the link
 * @param {boolean} disabled - if true will return a span instead of the link
 * @param {string} to - the page to route to
 * @param {string} className - the classes to apply to the tags
 */
const LinkWithDisable = ({
  children, className, disabled, to, onClick,
}) => {
  if (disabled) {
    return (
      <span className={className} data-testid={`disabled-link-to-${to}`}>
        {children}
      </span>
    );
  }
  return (
    <Link to={to} className={className} data-testid={`enabled-link-to-${to}`} onClick={onClick}>
      {children}
    </Link>
  );
};

LinkWithDisable.propTypes = {
  children: object.isRequired,
  className: string,
  disabled: bool,
  to: string.isRequired,
  onClick: func,
};

LinkWithDisable.defaultProps = {
  className: '',
  disabled: false,
  onClick: null,
};

export default LinkWithDisable;
